export const reducerKey = 'directDebitBankAccount'
